import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Field } from "@/components/yarn/Field";
import { api, errorText } from "@/lib/api";

const today = new Date().toISOString().slice(0, 10);

export function RegisterForm() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", email: "", birthdate: "", password: "" });
  const [busy, setBusy] = useState(false);
  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/register", form);
      if (data.email_sent) toast.success("Check your email for a 6-digit code.");
      else toast.error("Your account is saved, but the email didn't send. Tap resend on the next screen.");
      navigate(`/verify?u=${encodeURIComponent(data.username)}&hint=${encodeURIComponent(data.email_hint)}`);
    } catch (err) {
      toast.error(errorText(err));
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="register-form">
      <Field label="Username" id="reg-username" autoComplete="username" required minLength={3} maxLength={20}
        hint="3-20 letters, numbers or underscores. This is what other players see."
        value={form.username} onChange={set("username")} data-testid="register-username-input" />
      <Field label="Email" id="reg-email" type="email" autoComplete="email" required
        value={form.email} onChange={set("email")} data-testid="register-email-input" />
      <Field label="Birthdate" id="reg-birthdate" type="date" required max={today}
        hint="Under 18? You'll only see underage games."
        value={form.birthdate} onChange={set("birthdate")} data-testid="register-birthdate-input" />
      <Field label="Password" id="reg-password" type="password" autoComplete="new-password" required minLength={8}
        hint="At least 8 characters."
        value={form.password} onChange={set("password")} data-testid="register-password-input" />
      <button type="submit" className="btn-yarn w-full h-14 text-lg" disabled={busy} data-testid="register-submit-button">
        {busy ? "Casting on..." : "Create account"}
      </button>
    </form>
  );
}
